import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const BuilderForm = withSafeSuspense(lazy(
  async () => ({ default: (await import('./builder_form')).BuilderForm })
))
